import { InMemoryCache } from "@apollo/client";

const cacheOptions = "";

export class ApolloOptionsPlugin {
  apply({ addFilter }) {
    addFilter("apolloClientOptions", "faust", (apolloClientOptions) => {
      return {
        ...apolloClientOptions,
        // dataMasking: true,
        assumeImmutableResults: true, // https://www.apollographql.com/docs/react/api/core/ApolloClient#apolloclientoptions-assumeimmutableresults
        // cache: new InMemoryCache(),
      };
    });
  }
}
